import httpClient from '../httpClient';

const getIndicatorData = async (id) => {
  return await httpClient.get('/indicators/');
};

const indicatorsDetailsTable = async (i, page, pageSize, search) =>
  await httpClient.get(`/indicators/${i}_details/`, {
    params: {
      'page[number]': page,
      'page[size]': pageSize,
      ...(search ? { 'filter[search]': search } : {}),
    },
  });

export { getIndicatorData, indicatorsDetailsTable };
